export const SEARCH_FORM = {
  ref: "search_pl",
  name: "search_pl",
  id: "search_pl",
  label: "หมายเลขรหัส PL",
  span: 6,
};

export const DEVICEID_FORM = {
  ref: "deviceid",
  name: "deviceid",
  id: "deviceid",
  label: "หมายเลขเครื่องตัด",
  span: 6,
};
